<template>
  <div>
    <div v-if="data.type == 'texteditor'" v-html="value3" :style="style"></div>
    <l-radio
      v-else-if="data.type == 'switch'"
      :options="options4"
      v-model="value4"
      v-bind="data"
    ></l-radio>
    <div v-else-if="data.type == 'rate'" v-html="value5"></div>
    <div v-else-if="data.type == 'slider'" v-html="value6"></div>
    <component
      v-else
      :is="getPrintComponent(data.type)"
      v-model="value2"
      v-bind="data"
      :options="myOptions"
      :size="data.subfield ? 'mini' : data.size"
      :activeValue="toValueType(data.valueType, data.activeValue)"
      :inactiveValue="toValueType(data.valueType, data.inactiveValue)"
      :disabled="disabled"
      :isNotUpLoad="isPreview"
      :collapseTags="false"
      @change="handleChange"
    >
      <span v-if="data.html" v-html="data.html"></span>
      <template v-if="['input'].includes(data.type) && data.prepend" #prepend>
        {{ data.prepend }}
      </template>
      <template v-if="['input'].includes(data.type) && data.append" #append>
        {{ data.append }}
      </template>
    </component>
  </div>
</template>
<script>
import mixin from "../../mixin";
export default {
  name: "form-label",
  mixins: [mixin()],
  props: {
    value: {},
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isForm: {
      // 是否表单里的对象，用来区分对查询框的操作
      type: Boolean,
      default: false,
    },
    upCtrls: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isRead: {
      // 是否表单里的对象，用来区分对查询框的操作
      type: Boolean,
      default: false,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    value2: {
      get() {
        if (this.isEmpty) {
          return null;
        }
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    value3: {
      get() {
        if (this.isEmpty) {
          return null;
        }
        let val = this.value;
        if (this.apiUrl) {
          val = val
            .replace(/{learun_img_api}/g, `${this.apiUrl}system/annexesfile/`)
            .replace(/{learun_img_token}/g, `token=${this.token}`);
        }
        console.log(this.apiUrl);
        return val;
      },
    },
    options4: {
      get() {
        let val = [
          {
            value: this.data.inactiveValue,
            label: this.data.inactiveText
              ? this.$t(this.data.inactiveText)
              : "关闭",
          },
          {
            value: this.data.activeValue,
            label: this.data.activeText
              ? this.$t(this.data.activeText)
              : "开启",
          },
        ];
        return val;
      },
    },
    value4: {
      get() {
        if (this.isEmpty) {
          return null;
        }
        if (typeof this.value == "boolean") {
          return this.value ? this.data.activeValue : this.data.inactiveValue;
        } else {
          if (this.value) {
            return this.value;
          } else {
            return this.data.default;
          }
        }
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    options5: {
      get() {
        if (this.data.texts && this.data.texts.length > 0) {
          return "【评分项】" + this.data.texts.join(",");
        }
        return "";
      },
    },
    value5: {
      get() {
        /* 
        if (this.options5 && this.data.showText) {
          return  (!this.$validatenull(this.value2) ? this.value2 : "") + " " + this.options5
        }
        return this.value2
        */
        return (
          (!this.$validatenull(this.value2)
            ? this.value2
            : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;") +
          " 【分值】0 - " +
          this.data.max +
          (this.data.allowHalf ? "，允许半选" : "，请输入整数")
        );
      },
    },
    value6: {
      get() {
        return (
          (!this.$validatenull(this.value2)
            ? this.value2
            : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;") +
          " 【区间】" +
          this.data.min +
          " - " +
          this.data.max
        );
      },
    },
    style() {
      const height = this.$isNumber(this.data.height)
        ? this.data.height + "px"
        : this.data.height;

      return {
        height,
      };
    },
    disabled() {
      if (this.isRead) {
        return true;
      }

      if (this.data.subfield) {
        const abledList = this.formData.abledList || [];
        if (this.formData.disabled && abledList.indexOf(this.data.prop) == -1) {
          return true;
        }
      }
      return this.data.disabled;
    },
  },
  methods: {
    toValueType(type, value) {
      if (!this.$validatenull(value) && !this.$validatenull(type)) {
        switch (type) {
          case "boolean":
            return value == "true";
          case "string":
            return value;
          case "number":
            return Number(value);
        }
      }
    },
    handleChange(changeData) {
      this.$nextTick(() => {
        // 1.改变级联数据，清空级联数据
        if (
          [
            "checkbox",
            "radio",
            "select",
            "selectMultiple",
            "treeselect",
            "layerselect",
            "companySelect",
            "departmentSelect",
            "userSelect",
          ].includes(this.data.type)
        ) {
          this.clearSubValue(this.data.prop);
        }
        // 根据右侧赋值字段给表单赋值地图信息
        if (this.data.type == "layerbmap") {
          if (this.data.bindaddr) {
            if (changeData) {
              this.$set(this.formData, this.data.bindaddr, changeData.address); //设置绑定地址
            } else {
              this.$set(this.formData, this.data.bindaddr, ""); //设置绑定地址
            }
          }
          if (this.data.bindaddrpoint) {
            if (changeData) {
              this.$set(
                this.formData,
                this.data.bindaddrpoint,
                `${changeData.lng},${changeData.lat}`
              ); //设置绑定经纬度
            } else {
              this.$set(this.formData, this.data.bindaddrpoint, ""); //设置绑定地址
            }
          }
        }
        // 弹窗赋值
        if (this.data.type == "layerselect") {
          this.data.columns.forEach((col) => {
            if (col.valueKey) {
              if (changeData) {
                this.$set(this.formData, col.valueKey, changeData[col.prop]);
              } else {
                this.$set(this.formData, col.valueKey, undefined);
              }
            }
          });
        }
        this.$emit("change", { prop: this.data.prop, obj: changeData });
      });
    },
    clearSubValue(upProp) {
      if (this.upCtrls[upProp]) {
        this.upCtrls[upProp].forEach((prop) => {
          this.$set(this.formData, prop, "");
          this.clearSubValue(prop);
        });
      }
    },
  },
};
</script>